
class exports.Stage extends KoModel


    constructor: (parent, data = {}, deps = {}) ->
        super()
        @setInitialDeps()
        @syncDeps(deps)


        @parent             = parent

        @id                 = data.stage_id ? null
        @population         = ko.observable parseInt(data.population ? 0)
        @musym              = data.musym
        @mukey              = data.mukey
        @yield              = data.yield ? null
        @field_soil_acres   = data.field_soil_acres ? null
        if @field_soil_acres?
            @field_soil_acres = parseFloat(@field_soil_acres).toFixed(1)

        @soil_color         = data.soil_color
        @soil_description   = data.soil_description
        @bags               = ko.computed () =>
            return Math.ceil((@population() * @field_soil_acres) / 80000)


        ###
        The explaination of this starts in PrescriptionMap.Layer.

        This evaluation is ALSO deferred, because we don't want every child
        to try calculating their percent acres as soon as they are created.
        This is because the total acres calculation should only happen /after/
        every child Stage has been instantiated.

        This calculation gets auto-triggered by knockout at usage; so when we try
        printing out the percent acres on the frontend, this gets calculated. By that
        point, all stages have been created, and the parent.total_acres can report a
        correct total acreage
        ###
        @percent_acres      = ko.computed
            read: () =>
                return ((@field_soil_acres / @parent.total_acres()) * 100).toFixed(1)

            deferEvaluation: true

